<script>
  import { createEventDispatcher } from "svelte";
  import Spinner from "../../components/HTMLElements/Spinner.svelte";

  const dispatch = new createEventDispatcher();

  export let backUrl = "";
  export let disabled = false;
  export let visible = true;
  export let buttonText = "";
  export let showContinueWithoutSigninButton = false;
  export let isPageLoading = true;
  export let showFooterButtons = true;
</script>

{#if isPageLoading}
  <Spinner />
{:else}
  <div class="column">
    {#if backUrl !== ""}
      <a
        tabindex="0"
        href="#"
        on:click|preventDefault={() => dispatch("pageChange", backUrl)}
      >
        <span class="fas fa-arrow-left" /> Back
      </a>
    {/if}

    <h1 class="title is-3" id="header" style="margin-top: 0.75rem;">
      Contact Support
    </h1>
  </div>

  <slot />

  {#if showFooterButtons}
    <hr />

    {#if showContinueWithoutSigninButton}
      <div
        class="columns is-desktop"
        style="margin-left: 0; margin-right: 0;"
      >
        <div class="column" style="flex-grow: 0;">
          <button
            class="button is-primary"
            {disabled}
            on:click={() => dispatch("handleNext")}
          >
            {buttonText}
          </button>
        </div>

        <div class="column" style="flex-grow: 0;">
          <button class="button" on:click={() => dispatch("handleContinue")}>
            Continue without signing in
          </button>
        </div>
      </div>
    {:else}
      <div class="columns" style="margin-left: 0; margin-right: 0;">
        <div class="column">
          <button
            class="button is-primary"
            {disabled}
            style="display: {visible ? "inline-block" : "none"}"
            on:click={() => dispatch("handleNext")}
          >
            {buttonText}
          </button>
        </div>
      </div>
    {/if}
  {/if}
{/if}
